import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, {
  retries: 5,
  retryDelay: () => {
    return 500;
  },
  retryCondition: (error: any) => {
    return (
      (error.response !== undefined &&
        error.response.status !== 400 &&
        error.response.status !== 401 &&
        error.response.status !== 420 &&
        error.response.status !== 500 &&
        error.response.status !== 504) ||
      error.response === undefined ||
      error.response.status === 500
    );
  },
});

const successInterceptor = (response: AxiosResponse) => response;

const reduceToResponseOnly = (err: any) => Promise.reject(err && err.response);

export class ApiCaller {
  public static getInstance(): ApiCaller {
    if (!ApiCaller.instance) {
      ApiCaller.instance = new ApiCaller();
    }

    return ApiCaller.instance;
  }

  private static instance: ApiCaller;

  private constructor() {
    axios.interceptors.response.use(successInterceptor, reduceToResponseOnly);
  }

  public configureHeaders(token: string | null) {
    const header = "Authorization";
    axios.defaults.headers.common[header] = token;
  }

  public async post(url: string, data: any): Promise<any> {
    return axios.post(url, data);
  }

  public async postWithoutRetry(url: string, data: any): Promise<any> {
    return axios.post(url, data, {
      // @ts-ignore
      "axios-retry": {
        retries: 0,
      },
    });
  }

  public async get(url: string): Promise<any> {
    return axios.get(url);
  }

  public async getWithoutRetry(url: string): Promise<any> {
    return axios.get(url, {
      // @ts-ignore
      "axios-retry": {
        retries: 0,
      },
    });
  }

  public async patch(url: string, data: any): Promise<any> {
    return axios.patch(url, data);
  }
}
